<template>
    <div class="app container">
        <!-- 地图 -->
        <div class="map-wrap" v-if="nLatitude && nLongitude && isMapShow">
            <case-map :arrAreaList="arrAreaList" @show-case-list="showCaseList" @map-change="mapTapChange" :nLatitude="nLatitude" :nLongitude="nLongitude" ref="caseMap" />
        </div>

        <div class="header-box">
            <div class="header">
                <div class="left">
                    <div @click="gouloadcase" class="icon-add">发布案例</div>
                </div>
                <div class="middle">
                    <div class="capsule">
                        <div class="seach" @click="getShow">搜索</div>
                        <div class="choice icon-address">
                            <span>{{ sCity ? sCity : "请选择" }}</span>
                        </div>
                    </div>
                </div>
                <!-- <div class="middle" @click="getShow">按条件搜索案例</div> -->
                <!-- <div class="right" @click="show">
                <span>{{ city ? city : "请选择" }}</span>
              </div> -->
            </div>
            <div class="tab-nav">
                <div :style="{'width':(100 / 4) + '%'}" v-for="(item, index) in searchConf.tab" :key="item.code">
                    <p :class="{ active: item.select }" @click="fastSearch(index,item)">
                        {{ item.name }}
                    </p>
                </div>
                <div :style="{'width':(100 / 4) + '%'}">
                    <p @click="toAntMap">冷暖风水</p>
                </div>
                <div :style="{'width':(100 / 4) + '%'}" v-for="(item, index) in searchConf.brand" :key="item.code">
                    <p :class="{ active: item.select }" @click="fastSearch(index,item)">
                        {{ item.name }}
                    </p>
                </div>
            </div>
            <div class="search" v-show="bShow">
                <div class="close" @click="getShow"></div>
                <div class="search-box">
                    <div class="leads-box">
                        <div class="input-box">
                            <label>小区名称</label>
                            <input type="text" placeholder="输入小区名称或关键字" v-model="rqname" placeholder-class="place" />
                        </div>
                        <div class="tag-box">
                            <label>案例类型</label>
                            <div class="list">
                                <template v-if="!allCase">
                                    <p :class="{ active: item.select }" @click="setSearchConfKey('topic_type', index)" v-for="(item, index) in searchConf.topic_type" :key="index">
                                        {{ item.name }}
                                    </p>
                                </template>
                                <p :class="{ active: allCase }" @click="selectAllCase()">
                                    全部案例
                                </p>
                            </div>
                        </div>
                        <div class="input-box">
                            <label>产品型号</label>
                            <input type="text" placeholder="输入产品型号搜索" v-model="proType" placeholder-class="place" />
                        </div>
                        <div class="tag-box">
                            <label>产品品类</label>
                            <div class="list">
                                <template v-if="!allCategory">
                                    <p :class="{ active: item.select }" @click="setSearchConfKey('cate', index)" class="tag" v-for="(item, index) in searchConf.cate" :key="index" v-show="item.type==0">
                                        {{ item.name }}
                                    </p>
                                </template>
                                <p :class="{ active: allCategory }" class="tag" @click="selectAllCategory">全部</p>
                            </div>
                        </div>
                        <div class="tag-box">
                            <label>品牌</label>
                            <div class="list">
                                <template>
                                    <p :class="{ active: item.select }" @click="setSearchConfKey('brand', index)" v-for="(item, index) in searchConf.brand" :key="index">
                                        {{ item.name }}
                                    </p>
                                </template>
                            </div>
                        </div>

                    </div>
                    <div class="footer-btn">
                        <p @click.stop="bShow = false">取消</p>
                        <p class="active" @click.stop="getseash(true)">确定</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- 案例列表	 -->
        <transition name="collapse-list">
            <case-list :arrCaseList="arrCaseList" @close-case-list="closeCaseList" v-if="isCaseListShow" />
        </transition>

        <!-- 遮罩层 -->
        <div class="mask" @click="isSearchShow = false" v-show="isSearchShow"></div>

        <div class="reposition" @click="reposition()">
            <img src="@/assets/images/navigation.png" alt="" />
        </div>

        <awesome-picker ref="picker" :anchor="anchor" :data="address" :colorConfirm="sColor" :colorCancel="sColor" swipeTime:500 @cancel="handlePickerCancel" @confirm="handlePickerConfirm" v-if="bPicker"></awesome-picker>

        <!-- 侧边栏 -->
        <div class="sidebar">
            <div class="list">
                <div class="item" @click="gocasemap">
                    <img src="~@/assets/images/case/icon_list.png" />
                    <p>列表<br />模式</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    // import addressPicker from "../../components/select/erji_select.vue";
    import caseMap from "@/components/map";
    import caseList from "@/components/case-list";
    import path from "@/path";
    import { Toast } from "mint-ui";
    import PullTo from "vue-pull-to";
    export default {
        components: {
            // addressPicker,
            PullTo,
            caseMap,
            caseList,
        },
        data() {
            return {
                allCategory: false, // 是否选择所有品类
                objList: {}, //省市id
                anchor: [
                    {
                        index: 0,
                        value: "",
                    },
                    {
                        index: 0,
                        value: "",
                    },
                ], //默认选中
                sColor: "#2395ff", //picker取消确定按钮颜色
                arrAnchor: [], //初始化默认值
                address: [], //地级联动列表
                addressData: [], //未解析的地级联动列表
                addressObj: {
                    province: "",
                    city: "",
                    area_id: "",
                },
                bPicker: false,
                isMapShow: false,
                isSearchShow: false, // 搜索显示
                isCaseListShow: false, // 案例列表显示
                domeCity: "",
                sCity: "",
                sProvince: "",
                // 121.492901,31.22506
                nLatitude: 0,
                nLongitude: 0,

                arrAreaList: [],
                arrCaseList: [],

                bShow: false,
                // 搜索配置文件
                rqname: "", //小区名字搜索
                proType: "",
                searchConf: {
                    house_area: [],
                    cate: [],
                    topic_type: [],
                },
                tab: "",
                sort: {
                    time_desc: 0,
                    time_asc: 0,
                    shares: 0,
                    collect_num: 0,
                },
                userinfo: {}, //用户信息

                bSearch: false, // 是否为搜索模式
                allCase: false,
            };
        },
        created() {
            this.sCity = this.$route.query.city;
            this.domeCity = this.$route.query.city;
            this.sProvince = this.$route.query.province;
            this.nLatitude = this.$route.query.latitude || "";
            this.nLongitude = this.$route.query.longitude || "";

            // this.nLatitude = '121.492901';
            // this.nLongitude = '31.22506';
            // console.log("url经纬度", this.nLatitude, this.nLongitude);
            this.getAreaList();

            path.post5(path.topicGetConf).then((res) => {
                if (res.data.error == 0) {
                    for (let key in res.data.data.result) {
                        let item = res.data.data.result[key];
                        for (let subitem of item) {
                            subitem.select = false;
                        }
                    }
                    res.data.data.result.cate.forEach((it) => {
                        it.type = 0;
                    });
                    res.data.data.result.brand.forEach((it) => {
                        it.type = 2;
                        // res.data.data.result.tab.push(it)
                    });
                    res.data.data.result.tab.forEach((it) => {
                        it.type = 1;
                        res.data.data.result.cate.push(it);
                    });
                    this.searchConf = res.data.data.result;
                } else {
                    this.$store.commit("loadSwitch", false);
                    Toast({
                        message: res.data.msg,
                        position: "bottom",
                        duration: 1200,
                    });
                }
            });
        },
        mounted() {
            // this.arrgoAddress();
        },
        computed: {},
        methods: {
            selectAllCategory() {
                this.allCategory = !this.allCategory;
                this.searchConf.cate.forEach((item) => (item.select = false));
            },
            toAntMap() {
                wx.miniProgram.redirectTo({ url: "/pages/ant_map/index/index" });
            },
            selectAllCase() {
                if (this.allCase) {
                    for (let item of this.searchConf.topic_type) {
                        item.select = false;
                    }
                } else {
                    for (let item of this.searchConf.topic_type) {
                        item.select = true;
                    }
                }
                console.log(this.searchConf)
                this.allCase = !this.allCase;
            },
            //跳转小程序发布案例
            gouloadcase() {
                this.$store.commit("loadSwitch", true);
                path.post5(path.getUser, {
                    user_id: this.$route.query.tp5Userid,
                }).then((res) => {
                    // console.log("用户信息", res);
                    this.userinfo = res.data.data.result;
                    this.$store.commit("loadSwitch", false);
                    //判断是否为直销员  ==0  不是直销员
                    if (res.data.data.result.sell_id == 0) {
                        // Toast({
                        // message: "您不是直销员",
                        // duration: 500,
                        // });
                        // setTimeout(() => {
                        wx.miniProgram.navigateTo({
                            url: "/pages/phoneauth/index?url=/pages/case/case_release_xue1/index&userid=0&topicid=0",
                        });
                        // }, 500);
                    } else {
                        wx.miniProgram.navigateTo({
                            url: "/pages/case/case_release_xue1/index",
                        });
                    }
                });
            },
            //picker点击取消
            handlePickerCancel: function () {
                let that = this;
                if (that.bCancel) {
                    that.bCancel = false;
                    that.anchor = that.arrSelect;
                } else {
                    that.bCancel = false;
                    // that.anchor = that.anchor;
                }

                this.bPicker = false;
            },
            handlePickerConfirm(e) {
                //console.log("确定", e);
                let that = this;
                that.caseList = [];
                that.page = 0;
                let select = e;
                that.arrSelect = select;
                let addressData = that.addressData;
                let objprovinces = addressData[0].find((item) => {
                    return item.name.indexOf(select[0].value.slice(0, 2)) > -1;
                });
                // //console.log("-->省", objprovinces);
                if (objprovinces) {
                    let objCity = addressData[objprovinces.id].find((item) => {
                        // //console.log('=>provincestest',item.name.indexOf(province.slice(0,2)))
                        return item.name.indexOf(select[1].value.slice(0, 2)) > -1;
                    });
                    let provinceId = objprovinces.id;
                    let cityId = objCity.id;
                    let province = objprovinces.name;
                    let city = objCity.name;
                    let obj = {};
                    obj.city_id = cityId;
                    obj.province_id = provinceId;
                    that.objList = obj;
                    that.bCancel = true;
                    that.city = city;
                    that.getseash();
                }
            },
            //地级列表
            arrgoAddress: function (callback) {
                var that = this;
                let addressList = [];
                let promers = function () {
                    return new Promise(function (resolve, reject) {
                        that.$store.commit("loadSwitch", true);
                        that.$http
                            .get(
                                "https://pro-core.babycdn.com/2021/aosmith/lottery/china.json"
                            )
                            .then((res) => {
                                // console.log(res);
                                // path.post5(path.getFoorplanCity, {}).then((res) => {
                                // that.$store.commit("loadSwitch", false);
                                var addressData = res.body.data.result;
                                that.addressData = addressData;
                                if (that.province) {
                                    let objprovinces = addressData[0].find(
                                        (item) => {
                                            return (
                                                item.name.indexOf(
                                                    that.province.slice(0, 2)
                                                ) > -1
                                            );
                                        }
                                    );
                                    //console.log("--1》", objprovinces);
                                    if (objprovinces) {
                                        let objCity = addressData[
                                            objprovinces.id
                                            ].find((item) => {
                                            return (
                                                item.name.indexOf(
                                                    that.city.slice(0, 2)
                                                ) > -1
                                            );
                                        });
                                        let province = objprovinces.name;
                                        let provinceId = objprovinces.id;
                                        let city = objCity.name;
                                        let cityId = objCity.id;
                                        let addressIndex = [];
                                        addressIndex[0] = addressData[0].findIndex(
                                            (item) => {
                                                return (
                                                    item.name.indexOf(
                                                        that.province.slice(0, 2)
                                                    ) > -1
                                                );
                                            }
                                        );
                                        addressIndex[1] = addressData[
                                            objprovinces.id
                                            ].findIndex((item) => {
                                            return (
                                                item.name.indexOf(
                                                    that.city.slice(0, 2)
                                                ) > -1
                                            );
                                        });
                                        let obj = {};
                                        obj.city_id = cityId;
                                        obj.province_id = provinceId;
                                        that.objList = obj;
                                        ////console.log("市", city);
                                        //console.log("列表", addressIndex, that.objList);
                                        let anchor = [
                                            {
                                                index: addressIndex[0],
                                                value: province,
                                            },
                                            { index: addressIndex[1], value: city },
                                        ];
                                        that.anchor = anchor;
                                        that.arrAnchor = anchor;
                                        //console.log('anchor',anchor)
                                    } else {
                                        ////console.log("-->+++hhhh");
                                        let anchor = [
                                            { index: 0, value: "" },
                                            { index: 0, value: "" },
                                        ];
                                        that.anchor = anchor;
                                        // this.getCaselist();
                                    }
                                }
                                let data = addressData[0];
                                var addressObj = [];
                                for (let p = 0; p < data.length; p++) {
                                    var children = [];
                                    let cityId = data[p].id;
                                    for (
                                        let c = 0;
                                        c < addressData[cityId].length;
                                        c++
                                    ) {
                                        let countyId = addressData[cityId][c].id;
                                        if (addressData[countyId]) {
                                            var areaList = [];
                                            var areaIdList = [];
                                            for (
                                                let k = 0;
                                                k < addressData[countyId].length;
                                                k++
                                            ) {
                                                areaList.push(
                                                    addressData[countyId][k]
                                                );
                                                areaIdList.push(
                                                    addressData[countyId][k].id
                                                );
                                            }
                                        }
                                        let cityObj = {
                                            value: addressData[cityId][c].name,
                                            id: addressData[cityId][c].id,
                                            // areaList: areaList,
                                            // areaIdList: areaIdList,
                                        };
                                        children.push(cityObj);
                                    }
                                    let obj = {
                                        value: data[p].name,
                                        id: data[p].id,
                                        children: children,
                                    };
                                    addressObj.push(obj);
                                }
                                // //console.log(addressObj);
                                addressList = addressObj;
                                resolve(addressList);
                                return;
                                // that.address = that.getCityName(provinceList);
                            });
                    });
                };
                promers().then((res) => {
                    this.address = res;
                    //console.log(this.address);
                });
            },
            fastSearch(index, item) {
                if (item.type == 1) {
                    // 设置当前选中项
                    this.searchConf.tab[index].select =
                        !this.searchConf.tab[index].select;
                    const active = this.searchConf.cate.findIndex(
                        (item) => item.code == this.searchConf.tab[index].code
                    );
                    // console.log(this.searchConf.cate);
                    // 设置 cate 中的选中项
                    if (~active) {
                        this.searchConf.cate[active].select =
                            this.searchConf.tab[index].select;
                    }
                    // 去除不限的选中项
                    this.searchConf["cate"].forEach((it, nIt) => {
                        if (it.code == 0) {
                            it.select = false;
                        }
                    });
                } else if (item.type == 2) {
                    this.searchConf.brand[index].select =
                        !this.searchConf.brand[index].select;
                    const active = this.searchConf.cate.findIndex(
                        (item) => item.code == this.searchConf.brand[index].code
                    );
                    // 设置 cate 中的选中项
                    if (~active) {
                        this.searchConf.cate[active].select =
                            this.searchConf.brand[index].select;
                    }
                    // 去除不限的选中项
                    this.searchConf["brand"].forEach((it, nIt) => {
                        if (it.code == 0) {
                            it.select = false;
                        }
                    });
                }
                this.getseash();
            },
            setSearchConfKey(key, index) {
                if (key == "cate" && this.searchConf[key][index].code == 0) {
                    if (this.searchConf[key][index].select) {
                        this.searchConf[key].forEach((it, nIt) => {
                            if (it.code != 0) {
                                it.select = false;
                            }
                        });
                    } else {
                        this.searchConf[key].forEach((it, nIt) => {
                            if (it.code != 0) {
                                it.select = true;
                            }
                        });
                    }
                    this.searchConf[key][index].select =
                        !this.searchConf[key][index].select;
                } else {
                    this.searchConf[key].forEach((it, nIt) => {
                        // console.log(it);
                        if (it.code == 0) {
                            it.select = false;
                        }
                    });
                    this.searchConf[key][index].select =
                        !this.searchConf[key][index].select;
                }
            },
            //点击搜索案例初始化
            getShow: function () {
                this.bShow = !this.bShow;
            },
            //跳转附近案例
            gocasemap() {
                wx.miniProgram.redirectTo({
                    url: "/pages/case/case_list_vue/index",
                });
            },
            closeCaseList() {
                this.isCaseListShow = false;
            },
            showCaseList(e) {
                this.isCaseListShow = false;
                this.getCaseList(e.id);
            },
            //二级联动
            show() {
                this.bPicker = true;
                setTimeout(() => {
                    this.$refs.picker.show();
                }, 100);
            },
            // 重新定位
            reposition() {
                this.isMapShow = false;
                this.nLatitude = this.$route.query.latitude || "";
                this.nLongitude = this.$route.query.longitude || "";
                this.getAreaList();
            },

            // 点击地图
            mapTapChange(e) {
                // console.log(e)
                this.isMapShow = false;
                this.nLatitude = e.lat.toString();
                this.nLongitude = e.lng.toString();
                this.domeCity = e.city;
                if (this.bSearch) {
                    this.getseash();
                } else {
                    this.getAreaList();
                }
            },
            // 获取当前城市案例
            getAreaListV6() {
                let that = this;
                // todo 改回了老版本
                // const requestUrl = path.topicSearchplotsV6;
                const requestUrl = path.topicSearchplots;
                const requestData = {
                    longitude: that.nLongitude,
                    latitude: that.nLatitude,
                    distance: 30,
                    city_name: that.domeCity,
                    source: "xcx",
                };
                path.post5(requestUrl, requestData).then((res) => {
                    // let jsonUrl = res.data.data.result.url;
                    // that.$http.get(jsonUrl).then((obj) => {
                    //     that.arrAreaList = obj.body.list.filter(
                    //         (_) => _.topic_total != 0
                    //     );
                        that.arrAreaList = res.data.data.result.list.filter(
                            (_) => _.topic_total != 0
                        );
                        // console.log("案例列表", that.arrAreaList);
                        if (this.arrAreaList.length !== 0) {
                            that.getCaseList(that.arrAreaList[0].id);
                        } else {
                            that.$store.commit("loadSwitch", false);
                            that.$toast("该位置附近无案例小区~");
                            that.isMapShow = true;
                        }
                        that.bSearch = false;
                    // });
                });
            },
            // 获取小区位置
            getAreaList() {
                let that = this;
                const requestUrl = path.topicSearchplots;
                const requestData = {
                    longitude: that.nLongitude,
                    latitude: that.nLatitude,
                    distance: 60,
                    // city_name: that.sCity,
                    source: "xcx",
                };
                path.post5(requestUrl, requestData).then((res) => {
                    that.arrAreaList = res.data.data.result.list.filter(
                        (_) => _.topic_total != 0
                    );
                    // console.log("案例列表", that.arrAreaList);
                    if (this.arrAreaList.length !== 0) {
                        that.getCaseList(that.arrAreaList[0].id);
                    } else {
                        that.$store.commit("loadSwitch", false);
                        that.$toast("该位置附近无案例小区~");
                        that.isMapShow = true;
                    }
                    that.bSearch = false;
                });
            },

            // 搜索获取案例
            async getseash(from = false) {
                if (from) {
                    // 将搜索中选中的产品品类回填到界面的tab按钮
                    this.searchConf.cate.forEach((item) => {
                        this.searchConf.tab.forEach((it) => {
                            if (item.code == it.code) {
                                it.select = item.select;
                            }
                        });
                    });
                }

                this.$store.commit("loadSwitch", true);
                const requestUrl = path.topicSearchplots;
                let arr = [];
                for (let item of this.searchConf.house_area) {
                    // 选中的访问面积
                    if (item.select) {
                        arr.push(item.code);
                    }
                }
                let area = arr.join(",");

                arr = [];
                let arrBx = this.searchConf.cate.filter((it) => {
                    // 判断品类中的不限是否选中，选中会被添加到数组中
                    return it.select && it.code == 0;
                });
                if (arrBx.length) {
                    // 如果选中了品类中的不限
                    arr.push(0);
                } else {
                    // 未选中品类中的不限
                    for (let item of this.searchConf.cate) {
                        if (item.select) {
                            arr.push(item.code);
                        }
                    }
                }
                let parent_id = arr.join(","); // 选中的品类
                arr = [];
                for (let item of this.searchConf.topic_type) {
                    // 案列类型
                    if (item.select) {
                        arr.push(item.code);
                    }
                }
                let type = arr.join(",");
                arr = [];
                for (let item of this.searchConf.brand) {
                    // 案列类型
                    if (item.select) {
                        arr.push(item.code);
                    }
                }
                let brand_id = arr.join(",");
                let data = {
                    user_id: this.$route.query.userid,
                    longitude: this.nLongitude,
                    latitude: this.nLatitude,
                    search_keys: this.rqname,
                    page: 1,
                    limit: 20,
                    parent_id: parent_id,
                    model: this.proType,
                    type: type,
                    area: area,
                    distance: 30,
                    brand_id: brand_id,
                };
                // 快速搜索
                //   if(typeof from == "boolean"){
                //     arr = [];
                //     for(let item of this.searchConf.tab){
                //       if(item.select){
                //         arr.push(item.code);
                //       }
                //     }
                //     let parent_id = arr.join(',');

                //     data.search_keys = '';
                //     data.parent_id = parent_id;
                //     data.model = '';
                //     data.type = '';
                //     data.order = '';
                //     data.area = '';
                //   }
                let arrCate = this.searchConf["cate"].filter((it, nIt) => {
                    return it.select == true;
                });
                // 允许空搜索
                // if (
                //   arrCate.length == 0 &&
                //   !this.rqname &&
                //   !this.proType &&
                //   !type &&
                //   !area
                // ) {
                //   this.$store.commit("loadSwitch", false);
                //   this.$toast("请输入搜索条件");
                //   return false;
                // }

                const resultData = await path.post5(requestUrl, data);
                this.$store.commit("loadSwitch", false);
                this.isMapShow = false;
                this.$nextTick(() => {
                    this.isMapShow = true;
                    this.arrAreaList = resultData.data.data.result.list;
                    if (this.arrAreaList.length !== 0) {
                        this.getCaseList(this.arrAreaList[0].id);
                    } else {
                        this.$toast("暂无符合条件的小区");
                        this.arrCaseList = [];
                    }
                });
                this.bShow = false;
                this.bSearch = true;
            },

            // 获取案例
            getCaseList(id) {
                // console.log("id------->", id);
                this.isCaseListShow = false;
                this.$store.commit("loadSwitch", true);
                let arr = [];
                for (let item of this.searchConf.house_area) {
                    if (item.select) {
                        arr.push(item.code);
                    }
                }
                let area = arr.join(",");

                arr = [];
                let arrBx = this.searchConf.cate.filter((it) => {
                    return it.select && it.code == 0;
                });
                if (arrBx.length) {
                    arr.push(0);
                } else {
                    for (let item of this.searchConf.cate) {
                        if (item.select) {
                            arr.push(item.code);
                        }
                    }
                }
                let parent_id = arr.join(",");

                arr = [];
                for (let item of this.searchConf.topic_type) {
                    if (item.select) {
                        arr.push(item.code);
                    }
                }
                let type = arr.join(",");
                const requestUrl = path.getCaseList;
                const requestData = {
                    plot_id: id,
                    source: "xcx",
                    search_keys: this.rqname,
                    parent_id: parent_id,
                    model: this.proType,
                    type: type,
                    area: area,
                };
                path.post5(requestUrl, requestData).then((res) => {
                    let resultData = res;
                    this.$store.commit("loadSwitch", false);
                    this.arrCaseList = resultData.data.data.result.lists;
                    setTimeout(() => {
                        this.isCaseListShow = true;
                        this.isMapShow = true;
                    }, 200);
                    // console.log("案例", resultData.data.data.result);
                });
            },
        },
    };
</script>
<style lang="scss" scoped>
    @import "../../index";
    @import "index";
</style>